import store from '../store/'

export const locationsApi = {
    getAll () {
        return axios.get('/api/locations')
    },
}
